import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from 'src/app/services/login.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LoggerService } from 'src/app/services/loggerService.service';
import { PushNotificationService } from 'src/app/services/pushNotification.service';
import { SecurityService } from 'src/app/services/security.service';


@Component({
  selector: 'app-loader',
  imports: [CommonModule, TranslateModule],
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})

export class LoaderComponent {

  token: string | null = null;
  tinyToken: string | null = null;
  @Input() loaderMode: boolean = false;
  @Input() answer: string = '';
  @Input() error: string = '';

  constructor(private activateRoute: ActivatedRoute, private loginService: LoginService, private router: Router, private translate: TranslateService, private logger: LoggerService, private pushNotificationService: PushNotificationService,
    private securityService: SecurityService) {
  }

  ngOnInit(): void {
    if (!this.loaderMode) { //Esto sólo lo hace en el inicio

      console.log(this.activateRoute.snapshot);

      var param = this.activateRoute.snapshot.paramMap.get('param1')!;
      if (param == 'reconnect') {
        this.translate.get("RECONNECT").subscribe((text: string) => {
          this.answer = text;
        });
        this.token = '';
        this.loaderMode = true;
        return;
      }

      this.token = this.securityService.getUrlToken();

      console.log(this.token);

      if (this.token == null) {
        this.translate.get("FORCED_LEAVE").subscribe((text: string) => {
          this.answer = text;
        });
      } else {
        this.loginService.loginToken(this.token).subscribe({
          next: result => {
            this.answer = "TOKEN.TOKEN_OK";
            this.router.navigate(['waitingasset']);
            console.log('Todo ok:', result);
            this.pushNotificationService.startService();
          },
          error: errorMessage => {
            console.log('Error:', errorMessage);
            this.logger.error('Error en el inicio de sesión:', errorMessage);
            this.error = errorMessage;
          }
        });
      }
    }

    this.loaderMode = true;
  }

}
